<template>
    <v-card v-ripple="!readonly" flat tile class="pa-3 rest-card" @click="!readonly ? $emit('click') : null">
        <v-card-text class="pa-0">
            <v-row align="center">
                <v-col v-if="!readonly" cols="1" align="left" class="pl-0"/>
                <v-col cols="2" align="center">
                    <v-icon size="28" class="rest-icon">mdi-alarm-snooze</v-icon>
                </v-col>
                <v-col :cols="readonly ? '8' : '7'" class="px-2">
                    <div class="rest-lbl">{{ $t('exercises.rest') }}</div>
                    <div class="rest-time">{{ rest.time }}</div>
                </v-col>
                <v-col cols="2" align="right">
                    <v-btn icon small v-if="!readonly" @click.stop="onClickDelete">
                        <v-icon>$delete</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "RestCard",
    props: {
        rest: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClickDelete() {
            const vm = this
            vm.$emit('click:delete')
        },
    }
}
</script>

<style scoped>
.rest-card {
    background: transparent !important;
}

.rest-icon {
    color: var(--v-accent-base);
}

.theme--dark .rest-icon {
    color: var(--v-primary-base);
}

.rest-lbl {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}

.rest-time {
    font-size: 12px;
    color: var(--v-txtMuted-base);
}
</style>